/* eslint-disable eslint-comments/no-restricted-disable */
import type { EntryPoint, EntryPointComponent } from 'react-relay';
import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';
import type { AttributePrioritiesPageEntrypointProps } from './AttributePrioritiesPage.entrypoint.types.tsx';

type AttributePrioritiesEntryPointComponent = EntryPointComponent<
	{},
	{},
	AttributePrioritiesPageEntrypointProps,
	{}
>;

export const attributePrioritiesEntryPoint: EntryPoint<AttributePrioritiesEntryPointComponent, {}> =
	createEntryPoint({
		root: JSResourceForInteraction<AttributePrioritiesEntryPointComponent>(
			/* webpackChunkName: "async-attribute-priorities" */ './AttributePrioritiesPage.tsx',
		),
		getPreloadProps: () => ({
			extraProps: {},
		}),
	});
